import { createFileRoute } from '@tanstack/react-router';
import PlanDashboardPage from '../../../pages/PlanDashboardPage';

export const Route = createFileRoute('/_authenticated/$owner/plan')({
  component: () => <PlanDashboardPage />
});
